import React, { Fragment } from "react";
import { observer } from "mobx-react-lite";

import useModel from "../model/Model";
import ChangeColorBlock from "./ChangeColorBlock";
import { logObject } from "../model/utils";

const Toolbar = () => {
    const model = useModel();
    window.model = model;

    const isInProcess =
        model.modify ||
        model.delete ||
        model.changeColor ||
        model.addRoad ||
        model.selectRoads ||
        model.splitRoads ||
        model.exportPDF;
    // || model.shade !== false;

    // logObject(model.shade);

    return (
        <div id="toolbar">
            {!isInProcess && (
                <Fragment>
                    <button id="btnStart" disabled={model.drawing} onClick={model.startDrawing.bind(model)}>
                        Start drawing
                    </button>
                    <button id="btnStop" disabled={!model.drawing} onClick={model.stopDrawing.bind(model)}>
                        Stop drawing
                    </button>
                    <button
                        id="btnColor"
                        disabled={model.drawing || !model.polygons.length}
                        onClick={model.startChangeColor.bind(model)}
                    >
                        Change color
                    </button>
                    <button
                        id="btnModify"
                        disabled={model.drawing || !model.polygons.length}
                        onClick={model.startModify.bind(model)}
                    >
                        Modify polygon
                    </button>
                    <button disabled={model.drawing || !model.polygons.length} onClick={model.startDelete.bind(model)}>
                        Delete polygon
                    </button>
                    <button disabled={model.drawing || !model.polygons.length} onClick={model.startAddRoad.bind(model)}>
                        Add road
                    </button>
                    <button
                        disabled={model.drawing || !model.polygons.length}
                        onClick={model.startSelectRoads.bind(model)}
                    >
                        Select roads
                    </button>
                    <button
                        disabled={model.drawing || !model.polygons.length}
                        onClick={model.startSplitRoads.bind(model)}
                    >
                        Split roads
                    </button>
                    <button disabled={model.drawing || !model.polygons.length} onClick={model.exportKML.bind(model)}>
                        Export to KML
                    </button>
                    <button
                        disabled={model.drawing || !model.polygons.length}
                        onClick={model.startExportPDF.bind(model)}
                    >
                        Export to PDF
                    </button>
                    <button disabled={model.drawing || !model.polygons.length} onClick={model.nextShade.bind(model)}>
                        Shade
                    </button>
                    {model.shade !== false && <button onClick={model.endShade.bind(model)}>Stop shading</button>}
                    <div className="button button-with-dropdown" disabled={model.drawing}>
                        Stamps
                        <div className="button-dropdown">
                            <table>
                                <tbody>
                                    {Array.from({ length: 10 }, (_, i) => i + 1).map((i) => (
                                        <tr key={i}>
                                            <td onClick={model.addStamp.bind(model, `M${i}`)}>M{i}</td>
                                            <td onClick={model.addStamp.bind(model, `E${i}`)}>E{i}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <button disabled={model.drawing} onClick={model.addStart.bind(model)}>
                        Start
                    </button>
                    <button disabled={model.drawing} onClick={model.addText.bind(model)}>
                        Text
                    </button>
                </Fragment>
            )}

            {/* {JSON.stringify(model.changeColorPolygon)} */}

            {model.changeColor && (
                <>
                    <ChangeColorBlock />
                    <button
                        id="btnColor"
                        disabled={model.drawing || !model.polygons.length}
                        onClick={model.stopChangeColor.bind(model)}
                    >
                        Stop color changing
                    </button>
                </>
            )}

            {model.modify && (
                <Fragment>
                    <button id="btnModifySave" onClick={model.saveModify.bind(model)}>
                        Save modified
                    </button>
                    <button id="btnModifyCancel" onClick={model.cancelModify.bind(model)}>
                        Cancel modified
                    </button>
                </Fragment>
            )}
            {model.addRoad && <button onClick={model.stopAddRoad.bind(model)}>End add road</button>}
            {model.selectRoads && (
                <Fragment>
                    <button onClick={model.endSelectRoads.bind(model)}>End select roads</button>
                    <button onClick={model.deleteSelectedRoads.bind(model)}>Delete selected roads</button>
                </Fragment>
            )}

            {model.splitRoads && <button onClick={model.endSplitRoads.bind(model)}>End split roads</button>}
            {model.delete && <button onClick={model.endDelete.bind(model)}>End delete polygon</button>}

            {model.exportPDF && <button onClick={model.stopExportPDF.bind(model)}>End export PDF</button>}

            {model.totalHouseholds > 0 && <div className="total-households">Households: {model.totalHouseholds}</div>}

            {/* {model.shade !== false && (
                <Fragment>
                    <button onClick={model.nextShade.bind(model)}>Shade next</button>
                    <button onClick={model.endShade.bind(model)}>Stop shading</button>
                </Fragment>
            )} */}
        </div>
    );
};

export default observer(Toolbar);
